import { NotificationBaseDto } from './notification-base-dto';

export class NotificationWorkItemDto extends NotificationBaseDto {
  workItemId: number;
  oldStatus: number;
  newStatus: number;
  processId: number;
  processName: string;
  activityId: number;
  activityName: string;
  taskId: number;
  taskName: string;
  clientId: number;
  clientName: string;
  dueDate: string; // DayJS

  comment: string;
  sourceUserName: string;

  subType: NotificationWorkItemSubType;
}

export enum NotificationWorkItemSubType {
  UpdateStatus = 'UpdateStatus',
  TaggedUser = 'TaggedUser',
  QaUpdated = 'QaUpdated',
  AdHocCreated = 'AdHocCreated'
}
